module.exports = __webpack_public_path__ + "bootleggeres_coffee_box_mockup_packaging_design_corrugated_box_arabica5.jpg?e4b6f8d67694dbe6f426388a791306a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggeres_coffee_box_mockup_packaging_design_corrugated_box_arabica5.jpg
// module id = 28
// module chunks = 0